<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogRecord"
      width="30%"
      :before-close="handleClose">
      <span>{{recordContent}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="sureDialog">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="titleNew ? titleNew : '视频播放'"
      :visible.sync="playVisible1"
      width="800px"
      height="600px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
      footer="false">
      <!--    <iframe src="../../static/ol_play_old.html?sf=PC" height="530px" width="760px" frameborder="0" scrolling="no"></iframe>-->
      <div :class="fullShow ? 'videoBox' : ''">
        <video ref="video" :src="srcNew" :width="width" :height="height" autoplay @timeupdate="timeupdate" @canplay="canplay"></video>
        <el-progress :percentage="percentage1" :format="format"></el-progress>
        <el-button @click="playClick" v-if="!play">播放</el-button>
        <el-button @click="playClick" v-if="play">暂停</el-button>
        <el-button @click="seekClick(10)">快进10秒</el-button>
        <el-button @click="seekClick(20)">快进20秒</el-button>
        <el-button @click="seekClick(-20)">快退20秒</el-button>
        <el-button @click="seekClick(-10)">快退10秒</el-button>
        <el-button v-if="!fullShow" @click="openClick">全屏</el-button>
        <el-button v-if="fullShow" @click="openClick">退出全屏</el-button>
      </div>

      <el-dialog
        title="提示"
        :close-on-click-modal="false"
        :visible.sync="onceLookVisible"
        width="30%"
        :before-close="handleCloseOnce"
        append-to-body>
        <span>你是否确定该工种课程的学习</span>
          <span slot="footer" class="dialog-footer">
          <el-button @click="handleCloseOnce">取 消</el-button>
          <el-button type="primary" @click="dialogOnceTrue">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <el-dialog
      width="360px"
      title="验证信息"
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :before-close="handleCloseInner"
      >
      <div class="testBox">验证信息失效，请前往移动端进行人脸识别验证</div>
      <div class="img-box">
        <div id="qrCode" ref="qrCodeDiv"></div>
      </div>
    </el-dialog>
    <answer-view v-if="answerView1" :checkCode="checkCode" :type="answerType" :answerId="newMxId" :olCurriculumId="olCurriculumId"></answer-view>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
//  二维码生成器
import QRCode from 'qrcodejs2'
import answerView from './answerView'

export default {
  name: 'playView',
  props: ['src', 'title', 'mxId'],
  computed: {
    ...mapState(['playVisible', 'jurisdictionVideo', 'answerVisible'])
  },
  components: {
    answerView
  },
  data () {
    return {
      titleNew: this.title,
      playVisible1: false,
      width: '760px',
      height: '500px',
      play: true,
      percentage1: 0,
      percentage: '00:00 / 00:00',
      fullShow: false,
      historyCurrent: 0,
      innerVisible: false,
      testFrom: 1,   // 显示的二维码弹窗 1视频播放弹窗验证 2答题弹窗验证
      testTime: null,
      srcNew: 'http://file.sxdsjcy.com/wurenjiJSY/20200820/2a57c3286eba4ec98fb771e94ea0ff71.mp4',
      // 播放视频更改
      srcNew1: this.src,
      // 学习记录
      recordId: null,
      // 学习id
      studyId: null,
      // 开始时间
      startTime: 0,
      getPerfectShow: null,
      // 判断是否有权限登录计时器
      getJurisdictionShow: null,
      // 答题判断是否有权限登录计时器
      getAnswerJurisdictionShow: null,
      // 判断权限时间计算，5分钟后依旧没有验证成功则自动跳出
      jurisdictionTime: 0,
      // 答题判断权限时间计算，5分钟后依旧没有验证成功则自动跳出
      answerViewJurisdictionTime: 0,
      // 默认有权限观看
      overtime: true,
      // 判断是否是第一次可以
      onceLook: false,
      onceLookVisible: false,
      //  判断是否是当前学习课程
      dialogRecord: false,
      // 获取当前播放时间是否大于1分钟
      playTime: false,
      //  答题页面展示
      answerView1: false,
      // 0创建 1更新
      isUp: 0,
      // 视频播放提示消息
      recordContent: '',
      //  课时id
      newMxId: this.mxId,
      // 答题状态 课时3 阶段2
      answerType: 3,
      // 是否有试题 1有  0无
      isHavSt: 0,
      checkCode: '',  // 创建验证 获取checkCode
      videoDuration: 0,  // 视频时长
      videoCheck: 0,      // 视频验证
      videoFaceCheck: false,      // 视频前两分钟是否通过人脸验证
      checkFlag: 1,  // 人脸验证（默认1通过， 0不通过）
      olCurriculumId: '',   // 课程ID
      faceVerification: false,   // 人脸验证是否通过
      olFinish: 0,  // 视频状态（0进行中，1已完成，2重复观看）
      answerCheck: 0 // 答题弹框次数，防止多次弹出答题弹框
    }
  },
  mounted () {
    this.getJudgeVide()
  },
  methods: {
    ...mapMutations(['setPlayVisible', 'setJurisdictionVideo', 'setAnswerVisible']),
    handleClose () {
      let that = this
      that.setPlayVisible(false)
      that.playVisible1 = false
      this.innerVisible = false
      this.onceLookVisible = false
      that.srcNew = ''
      if (that.testTime) {
        clearInterval(this.testTime)
      }
      if (that.getPerfectShow) {
        clearInterval(this.getPerfectShow)
      }
      if (this.getJurisdictionShow) {
        clearInterval(this.getJurisdictionShow)
      }
    },
    // 视频可播放时触发
    canplay() {
      this.videoDuration = this.$refs.video.duration
    },
    // 当目前的播放位置已更改时
    timeupdate () {
      this.$nextTick(() => {
        if (this.$refs.video && this.$refs.video.currentTime) {
          if (this.historyCurrent < this.$refs.video.currentTime) {
            this.historyCurrent = this.$refs.video.currentTime
          }
          if (parseInt(this.$refs.video.currentTime) >= 60) {
            this.playTime = true
          }
          this.getPercentage()
          if (this.$refs.video.currentTime === this.$refs.video.duration) {
            this.play = false
          }
          // 视频播放到80%的时候开启人脸验证
          if (this.videoDuration != 0 && (this.videoDuration * 0.8 > this.$refs.video.currentTime-0.1 && this.videoDuration * 0.8 < this.$refs.video.currentTime+0.1) && this.videoCheck == 0 && this.olFinish == 0) {
            this.videoCheck++
            this.testClick()
          }
          if (this.$refs.video.currentTime === this.$refs.video.duration && this.isHavSt === 1 && !this.play && this.answerCheck == 0) {
            this.answerCheck++
            this.showAnswer()
          }
        }
      })
    },
    playClick () {
      let that = this
      this.play = !this.play
      if (this.play && this.olFinish == 0) {
        if (this.overtime) {
          this.$refs.video.play()
          if (this.faceVerification) {
            this.getPerfectShow = setInterval(function () {
              that.getPerfect(1, that.studyId, that.startTime, that.recordId)
            }, 10000)
          }
        } else {
          this.testClick()
        }
      } else {
        this.$refs.video.pause()
      }
    },
    seekClick (val) {
      let time = this.$refs.video.currentTime + val
      if (val > 0 && time > this.historyCurrent && JSON.parse(sessionStorage.getItem('user')).roleId !== 2 && JSON.parse(sessionStorage.getItem('user')).roleId !== 3) {
        this.$message('当前视频无法快进')
      } else {
        this.getPercentage()
        this.$refs.video.currentTime = this.$refs.video.currentTime + val
      }
    },
    getPercentage () {
      if (this.$refs.video.currentTime && this.$refs.video.duration) {
        this.percentage1 = parseInt(this.$refs.video.currentTime / this.$refs.video.duration * 100)
        this.percentage = this.timer(this.$refs.video.currentTime) + '/' + this.timer(this.$refs.video.duration)
      }
    },
    // 设置进度条时间参数
    format () {
      return this.percentage
    },
    // 时间格式化
    timer (seconds) {
      let minute = Math.floor(seconds / 60)
      if (minute < 10) {
        minute = '0' + minute
      }
      let second = Math.floor(seconds % 60)
      if (second < 10) {
        second = '0' + second
      }
      return minute + ':' + second
    },
    // 全屏和退出全屏
    openClick () {
      this.fullShow = !this.fullShow
      if (this.fullShow) {
        this.width = window.innerWidth - 20
        this.height = window.innerHeight - 80
      } else {
        this.width = '760px'
        this.height = '500px'
      }
    },
    // 获取验证二维码
    testClick () {
      let that = this
      if (this.checkFlag == 1) {
        this.testFrom = 1
        this.innerVisible = true
        this.overtime = false
        this.play = false
        that.$nextTick(() => {
          that.$refs.video.pause()
        })
        that.setJurisdictionVideo(false)
        // 创建验证 获取checkCode
        this.$http({
          method: 'post',
          url: '/api/renren-fast/app/baidu/createFaceCheck',
          data: {
            recordId: this.recordId,
            mxId: this.newMxId
          }
        }).then((result) =>{
          if (result.data.code == 0) {
            this.checkCode = result.data.data.checkCode
            this.checkFlag = 0
            this.getQRCode(1)
          }
        })
      }
    },
    getQRCode(from) {
      this.$nextTick(() => {
        console.log(document.getElementById('qrCode'))
        document.getElementById('qrCode').innerHTML = ''
        // let text = "http://101.201.153.146:8062?token=" + sessionStorage.getItem('token') + "&id=" + 7
        // from 为1播放，为2试题
        let text = '{"token":"' + sessionStorage.getItem('token') + '","id":"' + this.recordId + '","userID":"' + JSON.parse(sessionStorage.getItem('user')).userId + '","checkCode":"' + this.checkCode + '","from":"' + from + '"}'
        /* eslint-disable no-new */
        new QRCode('qrCode', {
          text: text,
          width: 150,
          height: 150,
          // 二维码颜色
          colorDark: '#0a0a0a',
          // 二维码背景色
          colorLight: '#ffffff',
          // 容错率，L/M/H
          correctLevel: QRCode.CorrectLevel.M
        })
      })
    },
    // 获取某个课时的学习情况详情
    getVideoUrl () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olstudy/getStudyInfo',
        params: {
          mxId: that.newMxId
        }
      }).then((result) => {
        if (result.data.code === 0) {
          that.isHavSt = result.data.data.isHavSt
          that.$nextTick(()=>{
            that.olCurriculumId = result.data.data.olStudyEntity.curriculumId
          })
        } else {
          that.$message.error(result.data.msg)
          that.handleClose()
        }
      })
    },
    //  获取视频播放连接
    getPlayUrl (src) {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/oss/viewtime',
        params: {
          url: src,
          mxId: that.newMxId
        }
      }).then((result) => {
        // console.log(result)
        if (result.data.data.isplay == 'play') {
          that.playVisible1 = true
          that.srcNew = result.data.data.viewPath
          that.historyCurrent =  result.data.data.endTime
          that.olFinish = result.data.data.olFinish
          that.$nextTick(() => {
            that.$refs.video.currentTime = result.data.data.endTime
          })
          // olFinish（0进行中，1已完成，2重复观看）
          if (result.data.data.olFinish == 0) {
            that.$nextTick(() => {
              that.getPerfect(0, 0, 0, 0)
            })
          }
        } else {
          that.$message.error(result.data.data.isplay)
          that.handleClose()
        }
      })
    },
    //  更新学习情况
    getPerfect (isUp, studyId, startTime, recordId) {
      let that = this
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/olstudyrecord/perfect',
        data: {
          //  0创建，1修改
          isUp: isUp,
          // 学习记录ID
          recordId: recordId,
          // 学习ID
          studyId: studyId,
          // 开始时间
          startTime: startTime,
          // 结束时间
          endTime: that.historyCurrent,
          // 课时总时长
          mxCountTime: that.$refs.video.duration,
          // 课时id
          mxId: Number(this.newMxId)
        }
      }).then((result) => {
        // console.log(result)
        if (result.data.code === 0) {
          that.recordId = result.data.data.recordId
          that.studyId = result.data.data.studyId
          if (!that.jurisdictionVideo && JSON.parse(sessionStorage.getItem('user')).roleId !== 3) {
            that.testClick()
          }
        } else {
          that.$message.error(result.data.msg)
          that.handleClose()
        }
      })
    },
    //  调起人脸验证二维码后判断是否拥有权限
    getJurisdiction () {
      let that = this
      if (that.jurisdictionTime > 120000) {
        that.jurisdictionTime = 0
        that.play = true
        that.overtime = false
        that.handleClose()
        that.$message({
          message: '验证超时，请重新验证',
          type: 'warning'
        })
      }
      this.jurisdictionTime += 5000
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/baidu/queryCheckResult/' + this.checkCode
      }).then((result) => {
        if (result.data.data.checkFlag === 1) {
          that.checkFlag = 1
          that.faceVerification = true
          that.innerVisible = false
          that.overtime = true
          // 开启视频播放功能
          that.videoFaceCheck = true
          that.playClick()
          // 二维码定时器重新开启
          // that.testTime = setInterval(this.testClick, 60000)
          // 清除权限验证定时器
          clearInterval(this.getJurisdictionShow)
          // 记录当前登录状态是否验证成功
          that.setJurisdictionVideo(true)
        }
      })
    },
    // 关闭二维码弹窗
    handleCloseInner () {
      this.innerVisible = false
      this.handleClose()
      this.getJurisdictionShow ? clearInterval(this.getJurisdictionShow) : ''
      this.getAnswerJurisdictionShow ? clearInterval(this.getAnswerJurisdictionShow) : ''
    },
    // 关闭是否继续播放此课程弹窗
    handleCloseOnce () {
      this.handleClose()
    },
    //  确定观看此课程章节
    dialogOnceTrue () {
      this.onceLookVisible = false
      this.$refs.video.play()
      this.getPlayClick()
    },
    // 去答题弹框加载
    open1 (data, type, olFinish) {
      this.testTime ? clearInterval(this.testTime) : ''
      let that = this
      this.play = false
      this.$confirm(data, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (olFinish == 1) {
          that.checkCode = null
          that.answerView1 = true
          that.setAnswerVisible(true)
        } else {
          that.testFrom = 2
          that.innerVisible = true
          that.answerTestClick()
        }
        that.playVisible1 = false
        that.srcNew = ''
      }).catch(() => {
        if (type === 'close') {
          that.setPlayVisible(false)
          that.setAnswerVisible(false)
        }
      })
    },
    // 获取答题验证二维码弹窗
    answerTestClick () {
      // 创建验证 获取checkCode
      let that = this
      that.setJurisdictionVideo(false)
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/stfacecheckrecord/createFaceCheck',
        data: {
          mxId: this.newMxId
        }
      }).then((result) =>{
        if (result.data.code == 0) {
          this.checkCode = result.data.data.checkCode
          that.getQRCode(2)
        }
      })
    },
    //  答题调起人脸验证二维码后判断是否拥有权限
    getAnswerJurisdiction () {
      let that = this
      if (that.answerViewJurisdictionTime > 60000) {
        that.answerViewJurisdictionTime = 0
        that.handleCloseInner()
        that.$message({
          message: '验证超时，请重新验证',
          type: 'warning'
        })
      }
      this.answerViewJurisdictionTime += 5000
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/stfacecheckrecord/queryCheckResult/' + this.checkCode
      }).then((result) => {
        if (result.data.data.checkFlag == 1) {
          that.answerView1 = true
          that.setAnswerVisible(true)
          that.setJurisdictionVideo(true)
          that.handleCloseInner()
        }
      })
    },
    // 获取当前播放记录信息，判断是否是当前正在学习视频
    getJudgeVide () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olstudy/playPer',
        params: {
          mxId: that.newMxId
        }
      }).then((result) => {
        if (result.data.code === 0) {
          if (result.data.data.mxSt === 1) {
            // 课时答题
            that.newMxId = result.data.data.playPerMx.mxId
            that.answerType = 3
            that.open1('当前记录中有课时未答题，是否去答题', 'close')
            return
          } else if (result.data.data.stageSt === 1) {
            // 阶段答题
            that.newMxId = result.data.data.playPerMx.olCurriculumStage
            that.answerType = 2
            that.open1('当前记录中有阶段未答题，是否去答题', 'close')
            return
          }
          if (result.data.data.playPer === 0) {
            // 学习记录中存在记录，提示学习未完成学习列表    视频不可以播放阶段
            that.newMxId = result.data.data.playPerMx.mxId
            that.recordContent = result.data.data.message
            that.dialogRecord = true
            that.srcNew1 = result.data.data.playPerMx.mxVedio
            that.titleNew = result.data.data.playPerMx.mxTitle
          } else {
            if (result.data.data.message !== '继续正在学习中的课时？' && result.data.data.message !== '正在学习已完成的课时，是否继续学习？') {
              // 学习记录中无列表播放列表
              that.onceLook = true
            }
            // 获取当前视频播放链接
            that.getPlayUrl(this.srcNew1)
            //  获取当前播放视频详情
            that.getVideoUrl()
          }
        } else {
          that.$message({
            message: '网络异常，请联系管理员',
            type: 'warning'
          })
          that.setPlayVisible(false)
        }
      })
    },
    // 取消弹窗
    closeDialog () {
      this.setPlayVisible(false)
    },
    //  确定弹窗
    sureDialog () {
      this.dialogRecord = false
      // 获取当前视频播放链接
      this.getPlayUrl(this.srcNew1)
      //  获取当前播放视频详情
      this.getVideoUrl()
    },
    //  获取二维码及更新视频播放进度 定时器开启
    getPlayClick () {
      let that = this
      if (that.jurisdictionVideo) {
        if (JSON.parse(sessionStorage.getItem('user')).roleId !== 3 && this.olFinish == 0) {
          that.testTime = setTimeout(that.testClick, 60000)
        }
      }
    },
    //  是否可以答题
    showAnswer () {
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olstudy/info/' + this.studyId
      }).then((result) => {
        if (result.data.data.olFinish !== null && result.data.data.olFinish !== 0) {
          this.open1('去答题', '', result.data.data.olFinish)
        }
      })
    }
  },
  watch: {
    play (val) {
      let that = this
      if (!val && !that.overtime) {
        this.getPerfectShow ? clearInterval(that.getPerfectShow) : ''
      }
    },
    // 判断是否调起二维码
    innerVisible (val) {
      if (val) {
        this.testTime ? clearInterval(this.testTime) : ''
        this.getPerfectShow ? clearInterval(this.getPerfectShow) : ''
        if (this.testFrom == 1) {
          this.getJurisdictionShow = setInterval(this.getJurisdiction, 5000)
        } else {
          this.getAnswerJurisdictionShow = setInterval(this.getAnswerJurisdiction, 5000)
        }
      }
    },
    playTime (val) {
      if (this.onceLook && parseInt(this.historyCurrent) === 60) {
        this.$refs.video.pause()
        this.onceLookVisible = true
        return false
      }
      // 判断播放时长大于1分钟的时候开启人脸识别及传实时数据给后台
      if (val && !this.videoFaceCheck) {
        this.getPlayClick()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.videoBox{
  position: fixed;
  top: 0px;
  left: 0px;
  background: #ffffff;
  padding: 10px;
  width: 100%;
}
.noVideo{
  width: 100%;
  height: 300px;
  text-align: center;
  line-height: 300px;
}
.testBox{
  width: 100%;
  text-align: center;
}
.img-box{
  width: 100%;
  height: 100%;
  #qrCode{
    width: 150px;
    height: 150px;
    margin: 20px auto;
  }
}
</style>
<style>
.el-progress-bar{
  margin-right: -100px;
  padding-right: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/playView.vue